import Raven from 'raven-js';
import { HIDDEN_IN_APP_PRIVATE_NOT_INDEXABLE } from 'file-manager-components/constants/fileAccess';
import { uploadFile } from 'file-manager-components/api/uploadFile';
// @ts-expect-error Untyped module
import { updateOptimisticLockingOnFetchContent } from 'ContentEditorUI/redux/actions/appActions';
import { CLOSE_AUDIO_NARRATION_PANEL, OPEN_AUDIO_NARRATION_PANEL, UPDATE_AUDIO_NARRATION_STATE } from './actionTypes';
import { acceptAudio, fetchTranscriptViaProxy } from '../../api/AudioNarrationApi';
import { POST_NARRATION_TRANSCRIPTS_FOLDER } from '../../constants/audioNarration';
// @ts-expect-error Untyped module
import { updateTextToAudioFileId } from './postContentModelActions';
// @ts-expect-error Untyped module
import { save } from './postSaveActions';
export const openAudioNarrationPanel = {
  type: OPEN_AUDIO_NARRATION_PANEL,
  openedVia: 'settings-modal'
};
export const closeAudioNarrationPanel = {
  type: CLOSE_AUDIO_NARRATION_PANEL
};
export const updateAudioNarrationState = payload => ({
  type: UPDATE_AUDIO_NARRATION_STATE,
  payload
});
export const acceptNarration = (contentId, executionId) => async dispatch => {
  try {
    const resp = await acceptAudio(executionId, contentId);
    dispatch(updateOptimisticLockingOnFetchContent(resp.updatedBuffer, {
      expectedUpdate: true
    }));
    dispatch(updateTextToAudioFileId(resp.audioFile.id));
  } catch (err) {
    console.error('Error saving audio to files', err);
    Raven.captureException(err);
    throw err;
  }
};
export const removeNarration = () => async dispatch => {
  dispatch(updateTextToAudioFileId(null));
  const saveResult = await dispatch(save({
    isAutoSave: true
  }));
  if (saveResult.error) {
    console.error('Error removing audio:', saveResult);
    Raven.captureMessage('Error removing audio');
    throw saveResult.error;
  }
};
export const fetchTranscript = contentId => async dispatch => {
  const filePath = `${POST_NARRATION_TRANSCRIPTS_FOLDER}/content-${contentId}.json`;
  try {
    const transcriptData = await fetchTranscriptViaProxy(filePath);
    dispatch(updateAudioNarrationState({
      hasFetchedTranscript: true,
      transcriptText: transcriptData.transcriptText,
      voice: transcriptData.voice
    }));
  } catch (err) {
    dispatch(updateAudioNarrationState({
      hasFetchedTranscript: true
    }));
  }
};
export const saveTranscript = (contentId, transcriptText, voice) => async () => {
  const jsonData = JSON.stringify({
    transcriptText,
    voice
  });
  const jsonBlob = new Blob([jsonData], {
    type: 'text/json'
  });
  try {
    await uploadFile(jsonBlob, HIDDEN_IN_APP_PRIVATE_NOT_INDEXABLE, {
      fileName: `content-${contentId}.json`,
      folderPath: POST_NARRATION_TRANSCRIPTS_FOLDER,
      overwrite: true,
      preserveExtension: true
    });
  } catch (err) {
    console.error('Failed to save transcript to files', err);
    Raven.captureException(err);
  }
};